import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppFloating from "./components/whatsapp";
import InstagramFloating from "./components/insta";
import Home from "./pages/Home";
import Aboutus from "./pages/Aboutus";
import Contactus from "./pages/Contactus";
import Apple from "./pages/brand/apple/apple";
import AppleProducts from "./pages/brand/apple/products";
import Dell from "./pages/brand/dell/dell";
import DellProducts from "./pages/brand/dell/products";
import Asus from "./pages/brand/asus/asus";
import AsusProducts from "./pages/brand/asus/products";
import Acer from "./pages/brand/acer/acer";
import AcerProducts from "./pages/brand/acer/products";
import Hp from "./pages/brand/hp/hp";
import HpProducts from "./pages/brand/hp/products";
import Lenovo from "./pages/brand/lenovo/lenovo";
import LenovoProducts from "./pages/brand/lenovo/products";
import Msi from "./pages/brand/msi/msi";
import MsiProducts from "./pages/brand/msi/products";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <div className="relative">
        <InstagramFloating />
        <WhatsAppFloating />
        <Header />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aboutus" element={<Aboutus />} />
          <Route path="/contactus" element={<Contactus />} />
          <Route path="/refurbished-laptops/apple" element={<Apple />} />
          <Route path="/refurbished-laptops/apple/macbooks" element={<AppleProducts />} />
          <Route path="/refurbished-laptops/dell" element={<Dell />} />
          <Route path="/refurbished-laptops/dell/laptops" element={<DellProducts />} />
          <Route path="/refurbished-laptops/asus" element={<Asus />} />
          <Route path="/refurbished-laptops/asus/laptops" element={<AsusProducts />} />
          <Route path="/refurbished-laptops/acer" element={<Acer />} />
          <Route path="/refurbished-laptops/acer/laptops" element={<AcerProducts />} />
          <Route path="/refurbished-laptops/hp" element={<Hp />} />
          <Route path="/refurbished-laptops/hp/laptops" element={<HpProducts />} />
          <Route path="/refurbished-laptops/lenovo" element={<Lenovo />} />
          <Route path="/refurbished-laptops/lenovo/laptops" element={<LenovoProducts />} />
          <Route path="/refurbished-laptops/msi" element={<Msi />} />
          <Route path="/refurbished-laptops/msi/laptops" element={<MsiProducts />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;


// need to check asus acer dell hp lenovo msi